import { BOBBY_API_ROOT } from '../constants';

export const USER_PATH = `${BOBBY_API_ROOT}/users/{hashId}`;
export const USER_PERMISSIONS_PATH = `${BOBBY_API_ROOT}/v2/users/{hashId}/permissions`;
export const APP_USERS_PATH = `${BOBBY_API_ROOT}/v3/users/app`;
export const USERS_PATH = `${BOBBY_API_ROOT}/v2/users`;
export const OLD_USERS_PATH = `${BOBBY_API_ROOT}/users`;
export const USERS_PATH_ACTIVATE = `${BOBBY_API_ROOT}/users/active`;
export const USERS_PATH_DEACTIVATE = `${BOBBY_API_ROOT}/users/inactive`;
export const DRIVERS_PATH = `${BOBBY_API_ROOT}/users/{driverType}`;
export const DRIVER_UPDATE_PATH = `${BOBBY_API_ROOT}/users/{driverType}/{hashId}`;
export const EXPORT_BO_USERS = `${USERS_PATH}/export`;
export const DOWNLOAD_BO_USERS = `${USERS_PATH}/download`;
export const DOWNLOAD_APP_USERS = `${BOBBY_API_ROOT}/users/app/download`;
